// KDS Logistics — 中/日双语内容数据

const data = {
  cn: {
    nav: ['首页', '关于我们', '服务', '据点・网络', '货物追踪', '联系我们'],
    // Hero
    hero: {
      kicker: 'Integrated Smart Supply Chain',
      title: ['连接世界，', '值得信赖的', '物流', '。'],
      lead: 'KDS是一家集国际运输、清关、仓储、跨境电商物流于一体的综合物流服务商。秉承"实惠、便捷、安全、高效"的理念，凭借中日及东南亚专属物流线路，助力企业全球化发展。',
      actions: [{ text: '服务一览', to: '#services' }, { text: '联系我们', to: '#contact' }],
      meta: [
        { num: '3,000+', label: '合作客户' },
        { num: '500,000+', label: '累计出口CBM' },
        { num: '10+', label: '年深耕' },
        { num: '20,000㎡+', label: '日本海外仓' },
      ],
      track: { title: '货物追踪', placeholder: '例: 202604260001', hint: '※ 追踪号可在运单或发货通知邮件中查看。' },
    },
    // Strengths
    strengths: {
      kicker: 'Our Strength', title: '选择KDS的6大理由',
      lead: '专业团队、强大伙伴网络、自营优势线路、一体化运营，KDS的优势直接转化为客户的业务价值。',
      items: [
        { num: '01', title: '20年+国际物流专业团队', desc: '精通国际运输、清关、运营的资深团队，对复杂订单始终保持一致的服务品质。' },
        { num: '02', title: '覆盖东南亚的专属线路', desc: '除日本、韩国、东南亚外，专属线路还延伸至印度、俄罗斯、中东等多个国家。' },
        { num: '03', title: '与一线承运商深度合作', desc: 'OCS、佐川急便、DHL、雅玛多、ANA、国泰、长荣海运等可信赖的国际运输网络。' },
        { num: '04', title: '从运输到配送的一体化体系', desc: '依托香港・深圳・广州・上海・青岛主要港口,实现报关、清关、配送的无缝衔接。' },
        { num: '05', title: '20,000㎡+日本海外仓', desc: '1pcs配送、散货发货、中转、验货、退换货、库存管理 — 7大功能一体化运营。' },
        { num: '06', title: '跨境电商・特殊货物对应', desc: 'FBA配送、冷链、医药化妆品、危险品等多品类、多场景的最优运输方案。' },
      ],
    },
    // Services overview
    servicesOverview: {
      kicker: 'Main Services', title: '主要服务',
      lead: '空运・海运・城市地面服务・仓储・跨境电商・特殊运输 — 根据您的货物特性，为您提供最佳物流方案。',
      cards: [
        { num: '01', title: '空运商业件到门', en: 'Air Commercial Door to Door', desc: '中国五大口岸直飞日本，24-48小时极速送达，最快1日达。空运包机・包板，多航线多航司一级代理商合作商。' },
        { num: '02', title: '海运商业件到门', en: 'Sea Commercial Door to Door', desc: '5-7个工作日，覆盖日本全口岸。特种柜・危险品・船运・特快游轮订舱代理，多航线多船公司服务商。' },
        { num: '03', title: '日本海外仓（一件代发）', en: 'Japan Overseas Warehouse', desc: '东京・大阪海外仓占地20,000㎡+，24小时发货，最快1-3天送达日本全境。智能OMS系统对接，自动补货。' },
        { num: '04', title: '空运FBA', en: 'Air FBA Service', desc: '3-5个工作日。FBA头程全托管，代收/验货/贴标/分箱，退货逆向物流，双清包税，敏感货专项方案。' },
        { num: '05', title: '海运FBA', en: 'Sea FBA Service', desc: '10-15个工作日。海运成本直降45%，提供日本进口商抬头，包逆算/包关税/包清关，全程无隐形费用。' },
        { num: '06', title: '日本合规备案', en: 'Japan Compliance Solutions', desc: '食品卫生法、药事法、METI备案、产品安全四法等多项合规备案方案，助力中国品牌顺利出海。' },
        { num: '07', title: '城市地面服务', en: 'City Ground Services', desc: '自营收派车队・拖车服务，主流国际航线城市地面无缝衔接，自营多功能仓库作业，报关报检商检一体化服务。' },
      ],
    },
    // Process
    process: {
      kicker: 'Operation Flow', title: '解决方案与运营流程', lead: '出口・进口分别优化的一体化流程，每一步都由KDS负责管理。',
      export: { label: 'EXPORT｜出口', steps: [
        { num: '01', title: '揽收', desc: '从客户指定地点收取货物。' },
        { num: '02', title: '出口报关', desc: '代办所需文件准备及法律手续。' },
        { num: '03', title: '国际运输', desc: '通过海运或空运将货物运至目的地。' },
        { num: '04', title: '最终派送', desc: '分拣后派送至指定收货地址。' },
      ]},
      import: { label: 'IMPORT｜进口', steps: [
        { num: '01', title: '到港', desc: '抵达香港海港或机场。' },
        { num: '02', title: '清关手续', desc: '完成进口清关与海关查验。' },
        { num: '03', title: '转运・出仓', desc: '转运至指定仓库并完成出仓作业。' },
        { num: '04', title: '最终派送', desc: '派送至客户指定地点。' },
      ]},
    },
    // Values
    values: {
      kicker: 'Customer Value', title: '为客户带来的6大价值',
      lead: '物流不只是运输，更是业务增长的引擎。KDS致力于为客户的销售扩张与成本优化提供直接价值。',
      items: [
        { num: '01', title: '订单成交率提升', desc: '准确的交付时效与可靠配送，提升复购率与新单成交率。' },
        { num: '02', title: '客户满意度提升', desc: '一致的品质管理与售后服务，持续提升客户满意度。' },
        { num: '03', title: '销售数量增长', desc: '灵活的物流体系防止因缺货导致的销售损失，支撑业务扩张。' },
        { num: '04', title: '更快的配送・更短的等待', desc: '专属线路与优化流程，大幅缩短前置时间。' },
        { num: '05', title: '更高的利润率', desc: '运输・仓储・清关的最优配置，实现利润率最大化。' },
        { num: '06', title: '物流成本降低', desc: '规模・经验・伙伴网络的综合优势，提供合理的总物流成本方案。' },
      ],
    },
    // Timeline teaser
    timeline: {
      kicker: 'Development History', title: '从2010年开始，挑战与成长。',
      lead: '自创立以来10余年，KDS不断扩展业务领域，与客户共同成长。',
      items: [
        { year: '2010', text: '深圳成立\n主营全球快递' },
        { year: '2013', text: '自建日本\n空派渠道' },
        { year: '2018', text: '自建海运\n物流渠道' },
        { year: '2020', text: '东京分公司成立\n自建海外仓' },
        { year: '2021', text: '千展供应链成立\n合规方案推出' },
        { year: '2025', text: '产品安全四法\n合规备案推出' },
      ],
      link: { text: '查看完整发展历程', to: '#about-history' },
    },
    // Qualifications
    qualifications: {
      kicker: 'Our Qualifications', title: '资质认证',
      lead: '获得国际行业组织及中国政府主管部门认可的可信物流伙伴。',
      items: [
        { name: 'IATA', desc: '国际航空运输协会成员' },
        { name: 'NVOCC', desc: '无船承运人资格' },
        { name: 'CIFA', desc: '一级货运代理企业' },
      ],
    },
    // Partners
    partners: {
      kicker: 'Strategic Partners',
      names: ['COSCO', 'EVERGREEN', 'SITC', 'CHINA SOUTHERN', 'SF AIRLINES', 'CATHAY PACIFIC', 'ANA', 'JAL', 'JP POST', 'YAMATO', 'SAGAWA', 'FUKUYAMA', 'SEINO', 'OCS', 'DHL', { text: '千展商行 SENTEN SHOKO', link: 'https://sentenshoko.co.jp/' }],
    },
    // CTA
    cta: { title: '为您的业务，配置最适合的物流。', desc: '报价咨询、专属线路定制，欢迎随时联系。', btn: '免费咨询' },
    // Footer
    footer: {
      brand: { name: 'KDS.,LTD', desc: '作为值得信赖的智能供应链服务商，致力于为客户实现业务价值最大化。' },
      service: { title: 'Service', links: ['空运服务', '海运服务', '城市地面服务', '海外仓', 'FBA配送', '合规备案'] },
      company: { title: 'Company', links: ['关于我们', '据点・网络', '货物追踪', '联系我们'], extLinks: [{ text: '株式会社千展商行 ↗', href: 'https://sentenshoko.co.jp/' }] },
      contact: { title: 'Contact', label: '深圳总部', addr: '深圳市坪山区\n坑梓街道梓祥路6-4号五栋1楼', phone1: '139-2349-2578', phone2: '135-1073-1969', email: 'david.qiu@kds868.com' },
      bottom: 'KDS.,LTD',
    },
    // About page
    about: {
      hero: { breadcrumb: 'HOME / ABOUT', title: '关于我们', lead: '2010年成立，作为日本专线庄家行业领导者，已为3000+客户提供中日间物流服务。' },
      stats: [
        { num: '3,000', sup: '+', label: '合作客户', em: 'Clients' },
        { num: '500,000', sup: '+', label: '累计出口货量CBM', em: 'Export Volume' },
        { num: '10', sup: '+', label: '年深耕', em: 'Years of Experience' },
        { num: '50', sup: '+', label: '在职员工', em: 'Staff Members' },
        { num: '20,000㎡', sup: '+', label: '日本海外仓', em: 'Japan Warehouse' },
      ],
      message: {
        kicker: 'About Us', title: ['连接世界，', '值得信赖的物流。'],
        body: [
          'KDS CO.LTD 成立于2010年，是国家商务部批准的<strong>一级货运代理企业</strong>，并获国家交通部颁发的<strong>"无船承运人（NVOCC）"资质</strong>。',
          'KDS是早期传统物流成功转型电商物流的服务商企业，凭借多年行业深耕沉淀，打造出多条自营优势渠道，助力中国品牌出海。',
          '旗下<strong>深圳市千展供应链有限公司</strong>隶属于KDS国际物流集团，提供进出口业务、海关手续、仓储保管、配送派送的一站式服务。作为日本专线庄家行业领导者，兼具稳定的服务品质与配送时效。',
          '"实惠、便捷、安全、高效"是我们的服务关键词。我们致力于打造兼顾社会价值与经济价值的高品质物流供应链服务平台。多年来获得众多客户的信任与支持，KDS不断稳健成长。',
          '未来，KDS将与客户和合作伙伴携手前行、共同成长，构建Win-Win的良好关系，为社会作出更多贡献，创造更多价值。',
        ],
      },
      history: {
        kicker: 'Development History', title: '发展历程',
        lead: '2010年成立至今，KDS不断扩展业务领域，未来仍将持续挑战，创造新价值。',
        items: [
          { year: '2010', title: 'KDS物流深圳成立', desc: '主营全球快递业务，于深圳创立。' },
          { year: '2013', title: '自建日本空派渠道', desc: '公司自建日本航空派送渠道，主营传统物流。' },
          { year: '2017', title: '坂田分公司成立・涉足电商物流', desc: '于深圳市龙岗区坂田设立分公司，开始涉及电商物流业务。' },
          { year: '2018', title: '自建海运物流渠道', desc: '公司自建海运物流渠道，确立空运・海运双轨体制。' },
          { year: '2019', title: '宝安分公司成立', desc: '于深圳市宝安区设立分公司，主营同行业务（货代向）。' },
          { year: '2020', title: '东京分公司成立・自建海外仓', desc: '日本东京分公司成立，于日本国内自建海外仓。' },
          { year: '2021', title: '千展供应链成立・合规方案推出', desc: '深圳市千展供应链有限公司成立。推出日本食品界、儿童玩具、药事法合规解决方案。' },
          { year: '2025', title: '产品安全四法 合规备案方案', desc: '推出日本《产品安全四法》（电气用品安全法・消费生活用品安全法・燃气事业法・液化石油气法）合规备案方案。' },
          { year: 'Future', title: '持续创新前行', desc: '与客户共创，持续打造新物流服务。', future: true },
        ],
      },
      culture: {
        kicker: 'Company Culture', title: '企业文化',
        vision: { en: 'CORPORATE VISION', title: '企业愿景', desc: '成为值得信赖的综合智能供应链服务商', sub: 'To become a trustworthy integrated intelligent supply chain service provider' },
        spirit: { en: 'CORPORATE SPIRIT', title: '企业精神', desc: '用心服务。\n以热情和爱传递感动，\n以努力实现目标。' },
        core: { en: 'CORE VALUE', title: '核心价值观', desc: '值得信赖的物流企业。\n安心托付的\n可靠配送服务。' },
      },
      advantages: {
        kicker: 'Our Advantages', title: '我们的优势',
        lead: '基于20余年的国际物流经验，KDS构建了独特的核心优势。',
        items: [
          { num: '01', title: '20年+经验国际物流团队', desc: '行业经验丰富的资深专业人才，对复杂订单始终保持一致的服务品质。' },
          { num: '02', title: '充足的空海运仓位资源', desc: '与主要承运商建立稳固合作关系，旺季也能确保稳定的舱位与机位。' },
          { num: '03', title: '海内外多个自营仓库', desc: '深圳多据点与日本东京・大阪仓库，实现无缝衔接的物流流程。' },
          { num: '04', title: '强大的合作代理网络', desc: '遍布全球的可信赖伙伴网络，端到端保障配送品质。' },
          { num: '05', title: '可视化全链条物流', desc: '通过自有OMS系统，从下单到送达全流程实时可视化。' },
          { num: '06', title: '日本食品界・药事法做证', desc: '具备日本食品进口・医药品相关法规对应的认证・通关支持能力。' },
          { num: '07', title: '日本METI合规备案', desc: 'METI（经济产业省）合规备案，日本市场进入所需的行政手续一站式办理。' },
        ],
      },
      qualifications: {
        kicker: 'Our Qualifications', title: '资质认证',
        lead: '获得国际行业组织与中国政府主管部门认可的可信物流伙伴。',
        items: [
          { name: 'IATA', desc: '国际航空运输协会成员', sub: 'IATA Member' },
          { name: 'NVOCC', desc: '无船承运人资格', sub: 'Non-Vessel Operating Common Carrier' },
          { name: 'CIFA', desc: '一级货运代理企业认定', sub: 'Class-A Freight Forwarder' },
        ],
      },
      profile: {
        kicker: 'Company Profile', title: '公司信息',
        rows: [
          { th: '公司名', td: 'KDS CO.LTD' },
          { th: '关联公司', td: '深圳市千展供应链有限公司（KDS国际物流集团）\n株式会社千展商行（日本法人）' },
          { th: '成立时间', td: '2010年' },
          { th: '员工人数', td: '50人以上' },
          { th: '业务内容', td: '国际物流（空运・海运・陆运）／清关业务／仓储・3PL／跨境电商物流／FBA配送／到门派送／冷链・特殊运输／日本合规备案' },
          { th: '总部地址', td: '深圳市坪山区坑梓街道梓祥路6-4号五栋1楼' },
          { th: '中国据点', td: '深圳市坪山区坑梓街道梓祥路6-4号五栋1楼\n深圳市龙岗区坂田街道中浩二路云力中心二楼218\n深圳市宝安区福海街道桥塘路福源工业区一栋1楼' },
          { th: '日本据点', td: '东京办公室：东京都涉谷区宇田川町1-12-1413（〒150-0042）\n东京仓库：埼玉县草加市八幡町（〒340-0006）\n大阪仓库：大阪府堺市中区（〒599-8266）\n日本海外仓合计 20,000㎡+' },
          { th: '业绩数据', td: '3,000+合作客户／累计出口货量 500,000+ CBM' },
          { th: '资质认证', td: 'IATA国际航空运输协会成员／NVOCC无船承运人资格／CIFA一级货运代理企业' },
          { th: '进出口口岸', td: '香港・深圳・广州・上海・青岛 等主要贸易港' },
          { th: '覆盖区域', td: '日本（专线庄家）／韩国／新加坡／马来西亚／泰国／菲律宾／印度／俄罗斯／中东诸国 等' },
        ],
      },
      cta: { title: '与KDS同行。', desc: '为您提供最适合的物流解决方案。', btn: '联系我们' },
    },
    // Services page
    services: {
      hero: { breadcrumb: 'HOME / SERVICES', title: '服务介绍', lead: '作为中日专线庄家行业领导者，提供空运・海运・FBA・海外仓・合规备案等一体化物流方案。' },
      transit: [
        { label: '空运商业 D2D', value: '最快1日达' },
        { label: '空运FBA', value: '3-5个工作日' },
        { label: '海运商业 D2D', value: '最快5日达' },
        { label: '海运FBA', value: '10-15个工作日' },
        { label: '海外仓发货', value: '1-3天（全境）' },
      ],
      details: [
        {
          id: 'air', num: 'SERVICE 01', title: '空运商业件到门', en: 'Air Commercial — Door to Door',
          leadTime: '最快1日达　／　24-48小时极速送达',
          desc: '中国五大口岸直飞日本。航班稳定无排空风险，专业报关团队中日双语文件处理，高效应对两国海关政策。',
          features: [
            { key: 'SPEED', val: '中国5大口岸→日本，24-48小时极速送达。' },
            { key: 'STABILITY', val: '专属航班，无排空风险，定时运行。' },
            { key: 'PAPERWORK', val: '中日双语文件处理，高效应对两国海关政策。' },
            { key: 'INSURANCE', val: '货物全程投保，涵盖运输风险。保障电子产品、精密仪器等高价值商品安全。' },
            { key: 'SENSITIVE', val: '恒温/防震包装方案，针对生鲜、医药、艺术品等敏感货物定制化服务。' },
          ],
        },
        {
          id: 'sea', num: 'SERVICE 02', title: '海运商业件到门', en: 'Sea Commercial — Door to Door',
          leadTime: '5-7个工作日　／　最快5日达',
          desc: '中国各大口岸直达日本，多航线，覆盖日本全口岸。支持FCL与LCL双模式。',
          features: [
            { key: 'FCL / LCL', val: '支持整柜（FCL）与拼箱（LCL）双模式。灵活混载配送。' },
            { key: 'VOLUME', val: '大货量享专属折扣＋保舱保柜服务。' },
            { key: 'STABILITY', val: '最快五日达，时效稳定，覆盖日本全口岸。' },
            { key: 'HAZMAT', val: '9类危险品合规运输，MSDS专业预审。' },
          ],
        },
        {
          id: 'ec', num: 'SERVICE 03', title: '空运FBA', en: 'Air FBA Service',
          leadTime: '3-5个工作日',
          desc: '完美对应Amazon FBA的空运服务。从FBA头程到退货逆向物流，一站式解决电商企业的痛点。',
          features: [
            { key: 'FULL CARE', val: 'FBA头程全托管，代收/验货/贴标/分箱。' },
            { key: 'FBA READY', val: '严格按亚马逊入仓要求预处理，避免货件被拒。' },
            { key: 'RETURNS', val: '退货逆向物流。支持日本本土退换货返华，一站式解决售后难题。' },
            { key: 'TAX INCLUDED', val: '空运双清包税。解决高额关税困扰。专属Prime会员备货通道，支持紧急补货，不断货保排名。' },
            { key: 'SENSITIVE', val: '敏感货专项方案：电池/化妆品/食品接触类商品合规出运（提供资质预审服务）。' },
          ],
        },
        {
          id: 'sea-fba', num: 'SERVICE 04', title: '海运FBA', en: 'Sea FBA Service',
          leadTime: '10-15个工作日　／　海运成本直降45%',
          desc: '兼顾海运的规模性与FBA配送的可靠性。提供海运普船、快船、整柜清、单票清多种通关模式。',
          features: [
            { key: 'COST −45%', val: '海运成本直降45%。持续出货大幅压缩物流费。' },
            { key: 'MULTI MODE', val: '提供海运普船、海运快船、整柜清、单票清多模式通关。' },
            { key: 'JCT / IOR', val: '免费提供日本进口商抬头，日本JCT/IOR合规申报。' },
            { key: 'ALL INCLUSIVE', val: '包逆算/包关税/包清关，全程无隐形费用。' },
            { key: 'SENSITIVE PASS', val: '敏感货专项通道，带电/带磁/食品界/药事法合规出海100%包通关。' },
          ],
        },
        {
          id: 'warehouse', num: 'SERVICE 05', title: '日本海外仓（一件代发）', en: 'Japan Overseas Warehouse',
          leadTime: '24小时发货　／　日本全境1-3天送达',
          desc: 'KDS海外仓设立在东京和大阪，占地20,000㎡+，离码头和机场1小时车程，交通发达。同时可作业20条柜以上。',
          features: [
            { key: 'FACILITY', val: '东京・大阪自营仓库20,000㎡+。同时可作业20+条柜。' },
            { key: 'BONDED', val: '设立有保税仓和海外仓，优化进口现金流。' },
            { key: 'OMS', val: '通过强大OMS系统对接，实时库存监控，订单自动化处理，运营更轻松。' },
            { key: 'SHIP IN 24H', val: '实现24小时发货，最快1-3天送达日本全境。' },
            { key: 'SMART', val: '智能系统支持库存预警、自动补货，避免断货或积压。' },
          ],
        },
        {
          id: 'compliance', num: 'SERVICE 06', title: '日本合规备案', en: 'Japan Compliance Solutions',
          leadTime: '专业团队代办备案・认证支持',
          desc: '日本市场进入所需的各项法规对应。从认证取得到行政备案一站式办理，专业团队支持中国品牌出海。',
          features: [
            { key: 'FOOD LAW', val: '日本食品卫生法对应。食品进口备案、成分表确认、检验安排等。' },
            { key: 'PHARMA', val: '药事法（医药品医疗器械等法）对应。医疗器械、化妆品的进口许可支持。' },
            { key: 'METI', val: 'METI（经济产业省）合规备案、各项行政手续代办。' },
            { key: 'SAFETY 4 LAWS', val: '产品安全四法（电安法・消安法・燃气事业法・液石法）合规备案方案。' },
            { key: 'TOY REG', val: '儿童玩具・文具的安全标准・ST标志取得相关支持。' },
          ],
        },
        {
          id: 'special', num: 'SERVICE 07', title: '特殊运输・冷链物流', en: 'Cold Chain & Special Cargo',
          leadTime: '温度管理・专业运输方案',
          desc: '温度管理产品的安全运输与保管，医药品・化妆品・危险品等专业知识需求货物特性的最优运输方案。',
          features: [
            { key: 'COLD CHAIN', val: '恒温・冷藏・冷冻多温区，针对各类温度需求选择最优运输方式。' },
            { key: 'MEDICAL', val: '医疗器械・医药品的特殊运输。各国法规对应支持。' },
            { key: 'COSMETIC', val: '化妆品运输所需的文件・通关手续支持。' },
            { key: 'HAZMAT', val: '危险品特殊运输（9类对应）。IATA/IMDG合规安全运输。' },
            { key: 'HIGH VALUE', val: '电子产品・精密仪器・艺术品等高单价商品专业包装。' },
          ],
        },
      ],
      flow: {
        kicker: 'Operation Flow', title: '10步一体化运输流程', lead: '从询价到签收，每一步都由KDS负责管理。',
        steps: [
          { num: '01', title: '开户/询价', desc: '建立合作账户与价格方案确认。' },
          { num: '02', title: '订单确认', desc: '规格・时效・配送条件最终确认。' },
          { num: '03', title: '货物准备', desc: '包装・贴标・出货文件准备。' },
          { num: '04', title: '订舱/入仓', desc: '预订航班・船期，办理保税仓入仓手续。' },
          { num: '05', title: '出口报关', desc: '中国出口申报与清关手续完成。' },
          { num: '06', title: '装货运输', desc: '空运・海运国际运输至日本。' },
          { num: '07', title: '进口清关', desc: '日本进口申报与海关查验完成。' },
          { num: '08', title: '目的港操作', desc: '港口・机场柜子取出与卸货作业。' },
          { num: '09', title: '海外仓分拣', desc: '必要时于KDS海外仓进行分拣・存储・FBA加工。' },
          { num: '10', title: '送货/签收', desc: '派送至最终收件人并签收完成。' },
        ],
      },
      coverage: {
        kicker: 'Full Coverage', title: '4大核心功能，全链路支持', lead: '从订单到签收、再到售后，每个环节都由KDS一体化管理。',
        items: [
          { num: '01', title: '订单管理', desc: '自有OMS系统统一管理从下单到出货的全流程，实时掌握订单状态。' },
          { num: '02', title: '仓储・库存管理', desc: '最新WMS系统支持的高效库存管理与SKU级综合保管・出货操作。' },
          { num: '03', title: '国际运输・追踪', desc: '覆盖全球的运输网络与高精度追踪系统，提供安心的运输状态可视化。' },
          { num: '04', title: '售后服务', desc: '包含退换货管理的全方位售后支持，助力业务持续运营。' },
        ],
      },
      cta: { title: '为您的货物，配置最佳方案。', desc: '服务组合咨询、报价请随时联系。', btn: '联系我们' },
    },
    // Network page
    network: {
      hero: { breadcrumb: 'HOME / NETWORK', title: '据点・网络', lead: '深圳3据点・日本3据点，与全球主要承运商及派送伙伴网络，构成KDS的独特专属线路。' },
      global: { kicker: 'Global Network', title: '连接全球的专属线路' },
      chinaOffices: {
        kicker: 'China Offices', title: '中国国内3大据点',
        lead: '深圳市内3大据点覆盖坪山・龙岗・宝安区域，各项业务的最优据点配置。',
        offices: [
          { pin: 'SHENZHEN PINGSHAN', title: '坪山据点（总部）', addr: '深圳市坪山区\n坑梓街道梓祥路6-4号五栋1楼', role: '主要运营据点。清关・仓储业务的核心。' },
          { pin: 'SHENZHEN BANTIAN', title: '龙岗坂田据点', addr: '深圳市龙岗区\n坂田街道中浩二路\n云力中心二楼218', role: '2017年设立。电商物流领域的核心据点。' },
          { pin: 'SHENZHEN BAOAN', title: '宝安据点', addr: '深圳市宝安区\n福海街道桥塘路\n福源工业区一栋1楼', role: '2019年设立。同行业务（货代向）的核心。' },
        ],
      },
      japanOffices: {
        kicker: 'Japan Offices', title: '日本国内据点',
        lead: '作为全球物流专家，于东京和大阪战略性配置据点，覆盖日本全境。',
        offices: [
          { pin: 'TOKYO OFFICE', title: '东京办公室', addr: '〒150-0042\n东京都涉谷区宇田川町1-12-1413', role: '全球战略与客户支持的中心据点。统管销售・客服。' },
          { pin: 'TOKYO WAREHOUSE', title: '东京仓库', addr: '〒340-0006\n埼玉县草加市八幡町', role: '关东圈物流主要枢纽。日本海外仓24小时发货对应。' },
          { pin: 'OSAKA WAREHOUSE', title: '大阪仓库', addr: '〒599-8266\n大阪府堺市中区', role: '实现西日本区域配送高效化的战略据点。最快1-3天送达全境。' },
        ],
      },
      chinaHubs: {
        kicker: 'China Hubs', title: '进出口5大贸易港',
        lead: '覆盖中国主要贸易港，提供运输・报关・清关・派送的一体化服务。',
        regions: [
          { en: 'SHENZHEN', cn: '深圳', sub: '总部・主要仓储据点' },
          { en: 'HONG KONG', cn: '香港', sub: '进出口中转・主要海港・机场' },
          { en: 'GUANGZHOU', cn: '广州', sub: '华南区域物流枢纽' },
          { en: 'SHANGHAI', cn: '上海', sub: '华东区域贸易港' },
          { en: 'QINGDAO', cn: '青岛', sub: '华北区域海运据点' },
        ],
      },
      asia: {
        kicker: 'Asia & Beyond', title: '专属线路展开区域',
        lead: '在日本・韩国・东南亚专属物流线路成功经营基础上，专属线路还延伸至印度・俄罗斯・中东诸国。',
        regions: [
          { en: 'JAPAN', cn: '日本（专线庄家）' },
          { en: 'KOREA', cn: '韩国' },
          { en: 'SOUTHEAST ASIA', cn: '新加坡・马来西亚・泰国・菲律宾 等' },
          { en: 'INDIA', cn: '印度' },
          { en: 'RUSSIA', cn: '俄罗斯' },
          { en: 'MIDDLE EAST', cn: '中东诸国' },
        ],
      },
      carriers: {
        kicker: 'Strategic Carriers', title: '合作承运商',
        lead: '与海运・空运主要承运商建立长期合作关系，确保稳定的舱位与机位资源。',
        groups: [
          {
            cat: '海运合约 — Sea Carriers',
            items: [
              { en: 'JJ SHIPPING', cn: '锦江航运' },
              { en: 'EVERGREEN', cn: '长荣海运' },
              { en: 'SITC', cn: 'SITC国际' },
              { en: 'T.S. LINES', cn: '德翔海运' },
              { en: 'COSCO', cn: '中远海运' },
            ],
          },
          {
            cat: '空运包板・包机 — Air Carriers',
            items: [
              { en: 'CHINA SOUTHERN', cn: '中国南方航空' },
              { en: 'SF AIRLINES', cn: '顺丰航空' },
              { en: 'CATHAY PACIFIC', cn: '国泰航空' },
              { en: 'ANA', cn: '全日空' },
              { en: 'JAL', cn: '日本航空' },
            ],
          },
          {
            cat: '日本国内派送伙伴 — Japan Last-Mile Partners',
            items: [
              { en: 'JP POST', cn: '日本邮便' },
              { en: 'YAMATO', cn: '雅玛多运输' },
              { en: 'SAGAWA', cn: '佐川急便' },
              { en: 'FUKUYAMA', cn: '福山通运' },
              { en: 'SEINO', cn: '西浓运输' },
              { en: 'TONAMI', cn: 'TONAMI' },
            ],
          },
          {
            cat: '国际物流伙伴 — International Express',
            items: [
              { en: 'OCS', cn: 'OCS World Network' },
              { en: 'DHL', cn: 'DHL Express' },
            ],
          },
        ],
      },
      cta: { title: '您的目的地，KDS来连接。', desc: '新线路建设咨询也欢迎联系。', btn: '联系我们' },
    },
    // Tracking page
    tracking: {
      hero: { breadcrumb: 'HOME / TRACKING', title: '货物追踪', lead: '输入追踪号即可实时查询货物配送状态。' },
      form: { title: '追踪号查询', desc: '请输入运单或发货通知邮件中的追踪号。', placeholder: '例: 202604260001', hint: '示例追踪号：202604260001（配送中）／202604200088（已签收）' },
      empty: '未查询到对应追踪号。请确认号码后重新查询。',
      faq: {
        kicker: 'FAQ', title: '关于追踪',
        rows: [
          { th: '更新频率', td: '配送状态约每30分钟更新一次。受清关或航班影响，偶尔会有延迟。' },
          { th: '编号格式', td: '"KDS"+ 日期（YYYYMMDD）+ 4位流水号 为基本格式。可在发货通知邮件・运单中查看。' },
          { th: '无法查询时', td: '发货后可能存在登录待机时段。如半天以上仍未显示，请联系我们。' },
          { th: '多单查询', td: '当前追踪界面支持单条查询。企业客户可使用批量追踪API。' },
        ],
      },
    },
    // Contact page
    contact: {
      hero: { breadcrumb: 'HOME / CONTACT', title: '联系我们', lead: '报价咨询、专属线路定制、其他物流相关咨询，欢迎随时联系。' },
      info: {
        kicker: 'Get in touch', title: '联系方式', desc: '通常2个工作日内回复。如需紧急联系，请直接致电。',
        items: [
          { key: 'HQ', val: '深圳总部（坪山）\n深圳市坪山区坑梓街道梓祥路6-4号五栋1楼' },
          { key: 'SHENZHEN', val: '龙岗坂田据点：\n深圳市龙岗区坂田街道中浩二路云力中心二楼218\n\n宝安据点：\n深圳市宝安区福海街道桥塘路福源工业区一栋1楼' },
          { key: 'JAPAN', val: '东京办公室：\n东京都涉谷区宇田川町1-12-1413（〒150-0042）\n东京仓库：埼玉县草加市八幡町（〒340-0006）\n大阪仓库：大阪府堺市中区（〒599-8266）' },
          { key: 'HOURS', val: '工作日 9:00〜18:00\n（周末・节假日除外）' },
          { key: 'EMAIL', val: 'info@kds-logistics.example' },
          { key: 'PHONE', val: '+86 XXX-XXXX-XXXX' },
        ],
      },
      form: {
        fields: {
          name: '姓名', company: '公司名', email: '邮箱', phone: '电话',
          category: '咨询类别', message: '咨询内容',
        },
        placeholders: {
          name: '张三', company: '○○有限公司', email: 'example@company.com',
          phone: '+86 XXX-XXXX-XXXX', message: '请填写货物概要、出发地・目的地、希望时效等。',
        },
        categories: ['请选择', '空运服务', '海运服务', '日本海外仓', '跨境电商・FBA配送', '到门派送服务', '特殊运输・冷链物流', '日本合规备案', '报价请求', '其他咨询'],
        submit: '提交',
      },
    },
  },

  // ==================== JP ====================
  jp: {
    nav: ['ホーム', '会社概要', 'サービス', '拠点・ネットワーク', '追跡', 'お問い合わせ'],
    hero: {
      kicker: 'Integrated Smart Supply Chain',
      title: ['世界をつなぐ、', '確かな ', '物流', ' を。'],
      lead: 'KDSは、国際輸送・通関・倉庫・越境ECを一貫して提供する総合物流企業です。手頃な価格、便利、安全、スピーディーをキーワードに、日本・中国・東南アジアを結ぶ専用ラインで、ビジネスの成長を支えます。',
      actions: [{ text: 'サービス一覧', to: '#services' }, { text: 'お問い合わせ', to: '#contact' }],
      meta: [
        { num: '3,000+', label: 'CLIENTS' },
        { num: '500,000+', label: 'EXPORT CBM' },
        { num: '10+', label: 'YEARS' },
        { num: '20,000㎡+', label: 'JAPAN WAREHOUSE' },
      ],
      track: { title: '貨物追跡', placeholder: '例: 202604260001', hint: '※ 追跡番号は配送伝票・出荷通知メールでご確認いただけます。' },
    },
    strengths: {
      kicker: 'Our Strength', title: '選ばれる、6つの理由',
      lead: '専門性ある人材、強固なパートナー網、独自の専用ライン、そして一貫体制。KDSの強みは、お客様の事業価値に直結します。',
      items: [
        { num: '01', title: '業界経験豊富な専門人材', desc: '国際輸送・通関・運用に精通したベテランチームが、複雑な案件にも一貫した品質で対応します。' },
        { num: '02', title: '東南アジア全域の専用ライン', desc: '日本・韓国・東南アジアに加えインド・ロシア・中東まで、自社ネットワークで結びます。' },
        { num: '03', title: '大手キャリアとの強固な提携', desc: 'OCS・佐川急便・DHL・ヤマト運輸、ANA・キャセイ・チャイナエアラインなど、信頼の輸送網。' },
        { num: '04', title: '輸送〜配送までの一貫体制', desc: '香港・深圳・広州・上海・青島の主要港を活用し、税関申告・通関・配送をシームレスに。' },
        { num: '05', title: '50,000㎡の海外倉庫', desc: '1pcs配送・バラ出荷・中継・検品・返品対応・在庫管理まで、7つの機能を一括提供。' },
        { num: '06', title: '越境EC・特殊輸送に対応', desc: 'FBA配送、コールドチェーン、医療・化粧品、危険物まで、多様な貨物特性に最適化。' },
      ],
    },
    servicesOverview: {
      kicker: 'Main Services', title: '主要サービス',
      lead: '航空・海運・都市地上サービス・倉庫・越境EC・特殊輸送 — お客様の貨物特性に合わせた最適な物流ソリューションをご提案します。',
      cards: [
        { num: '01', title: '航空輸送・チャーター便', en: 'Air Transport & Charter Flights', desc: '緊急貨物や時間制約のある荷物に対応。ANA・キャセイ・チャイナエアラインなど主要航空会社と連携した、高速かつ柔軟な輸送網を提供します。' },
        { num: '02', title: '海上輸送（Clipper Service）', en: 'Sea Transport', desc: '高速船で最速2〜3日、コスト優先船で3〜6日。スピードとコストのバランスをお選びいただける、信頼性の高い国際海上輸送サービスです。' },
        { num: '03', title: '海外倉庫サービス', en: 'Overseas Warehouse', desc: '合計50,000㎡の倉庫に1pcs配送・バラ出荷・中継・検品・返品交換・在庫管理など7機能を集約。海外進出をワンストップで支援します。' },
        { num: '04', title: '越境EC・FBA配送', en: 'Cross-border E-commerce', desc: '航空便で約3日、海上便で約10日納品。Amazon FBAをはじめ越境ECに最適化した配送・在庫管理を一括提供します。' },
        { num: '05', title: '宅配サービス（Door-to-Door）', en: 'Delivery to Door Service', desc: '集荷から最終配達まで、シームレスに統合された宅配ネットワーク。中国・日本間の小口配送もスピーディーに対応します。' },
        { num: '06', title: '特殊輸送・コールドチェーン', en: 'Special & Cold Chain', desc: '温度管理が必要な製品、医療品・化粧品の特別輸送、危険物特殊輸送まで、専門知識を要する貨物に対応します。' },
        { num: '07', title: '都市地上サービス', en: 'City Ground Services', desc: '自社集配車両・トレーラー輸送、主要国際路線都市での地上シームレス連携、自社多機能倉庫、通関・検査・商品検査の一体化サービス。' },
      ],
    },
    process: {
      kicker: 'Operation Flow', title: 'ソリューションとプロセス', lead: '輸出・輸入それぞれに最適化された一貫プロセス。すべての工程をKDSが責任もって管理します。',
      export: { label: 'EXPORT｜輸出', steps: [
        { num: '01', title: 'ピックアップ', desc: 'お客様の指定場所から荷物を集荷します。' },
        { num: '02', title: '輸出通関', desc: '必要書類の準備・法的手続きを代行します。' },
        { num: '03', title: '国際輸送', desc: '海上または航空便で目的地まで輸送します。' },
        { num: '04', title: '最終配達', desc: '仕分け後、指定の納品先へ配送します。' },
      ]},
      import: { label: 'IMPORT｜輸入', steps: [
        { num: '01', title: '到着港', desc: '香港の海港または空港に貨物が到着します。' },
        { num: '02', title: '通関手続き', desc: '輸入通関と税関検査を完了します。' },
        { num: '03', title: '転送・搬出', desc: '指定倉庫への転送と搬出作業を行います。' },
        { num: '04', title: '最終配達', desc: 'お客様の指定場所へ配送します。' },
      ]},
    },
    values: {
      kicker: 'Customer Value', title: 'お客様にもたらす、6つの価値',
      lead: '物流は単なる輸送ではなく、ビジネスの成長エンジン。KDSは、お客様の売上拡大とコスト最適化に直結する価値を提供します。',
      items: [
        { num: '01', title: 'オーダー成約率UP', desc: '正確な納期と確実な配送で、リピート受注と新規成約率を高めます。' },
        { num: '02', title: '顧客満足度の向上', desc: '一貫した品質管理とアフターサービスで、顧客満足を継続的に向上。' },
        { num: '03', title: '販売数量の増加', desc: '柔軟な物流体制が、機会損失を防ぎ、販売拡大を支えます。' },
        { num: '04', title: '迅速な配送・短い待ち時間', desc: '専用ラインと最適化されたフローで、リードタイムを大幅に短縮。' },
        { num: '05', title: 'より高い収益性', desc: '輸送・倉庫・通関の最適配置で、利益率の最大化を実現します。' },
        { num: '06', title: '物流コストの削減', desc: '規模・経験・パートナー網を活かし、合理的な総物流コストを提案。' },
      ],
    },
    timeline: {
      kicker: 'Development History', title: '2010年から、挑戦と成長を。',
      lead: '設立から10年以上、KDSは事業領域を着実に拡大してきました。',
      items: [
        { year: '2010', text: '深圳で創業\nグローバル宅配を主軸に' },
        { year: '2013', text: '日本航空便ルートを\n自社構築' },
        { year: '2018', text: '海運物流ルートを\n自社構築' },
        { year: '2020', text: '東京支店設立\n日本海外倉構築' },
        { year: '2021', text: '千展供応链設立\nコンプラ対応開始' },
        { year: '2025', text: '製品安全四法\n備案対応開始' },
      ],
      link: { text: '沿革をすべて見る', to: '#about-history' },
    },
    qualifications: {
      kicker: 'Our Qualifications', title: '資格・認定',
      lead: '国際的な業界団体・中国政府関連機関から認定を受けた、信頼の物流パートナー。',
      items: [
        { name: 'IATA', desc: '国際航空運送協会会員' },
        { name: 'NVOCC', desc: '無船承運人資格' },
        { name: 'CIFA', desc: '一級貨運代理企業認定' },
      ],
    },
    partners: {
      kicker: 'Strategic Partners',
      names: ['COSCO', 'EVERGREEN', 'SITC', 'CHINA SOUTHERN', 'SF AIRLINES', 'CATHAY PACIFIC', 'ANA', 'JAL', 'JP POST', 'YAMATO', 'SAGAWA', 'FUKUYAMA', 'SEINO', 'OCS', 'DHL', { text: '千展商行 SENTEN SHOKO', link: 'https://sentenshoko.co.jp/' }],
    },
    cta: { title: 'あなたのビジネスに、最適な物流を。', desc: 'お見積もり・専用ライン構築のご相談、お気軽にどうぞ。', btn: '無料相談する' },
    footer: {
      brand: { name: 'KDS.,LTD', desc: '信頼される統合型スマートサプライチェーンサービスの提供企業として、お客様の事業価値最大化に貢献します。' },
      service: { title: 'Service', links: ['航空輸送', '海上輸送', '都市地上サービス', '海外倉庫', '越境EC', '宅配'] },
      company: { title: 'Company', links: ['会社概要', '拠点・ネットワーク', '貨物追跡', 'お問い合わせ'], extLinks: [{ text: '株式会社千展商行 ↗', href: 'https://sentenshoko.co.jp/' }] },
      contact: { title: 'Contact', label: '東京本社', addr: '〒150-0042\n東京都渋谷区宇田川町1-12-1413', phone1: '139-2349-2578', phone2: '135-1073-1969', email: 'david.qiu@kds868.com' },
      bottom: '© 2026 KDS.,LTD / 株式会社千展商行',
    },
    // About page (JP)
    about: {
      hero: { breadcrumb: 'HOME / ABOUT', title: '会社概要', lead: '2010年設立、日本専門線のリーディングカンパニーとして、3,000社超のお客様の中国-日本間物流をお支えしています。' },
      stats: [
        { num: '3,000', sup: '+', label: '合作客戸', em: '取引クライアント数' },
        { num: '500,000', sup: '+', label: '累計輸出量（CBM）', em: 'Export Volume' },
        { num: '10', sup: '+', label: '年の実績', em: 'Years of Experience' },
        { num: '50', sup: '+', label: '専門スタッフ', em: 'Staff Members' },
        { num: '20,000㎡', sup: '+', label: '日本海外倉', em: 'Japan Warehouse' },
      ],
      message: {
        kicker: 'Our Message', title: ['世界をつなぐ、', '確かな物流を。'],
        body: [
          'KDS CO.LTD は、2010年に深圳で設立された国際物流企業です。中国国家商務部が認可する<strong>一級貨運代理企業</strong>であり、国家交通部発行の<strong>「無船承運人（NVOCC）」資格</strong>を有しています。',
          '創業当初の伝統物流から、いち早くEC物流へ事業転換に成功した先駆けの企業として、長年にわたる業界経験を活かし、複数の自社優位ルートを構築。中国ブランドの海外進出を多角的に支援しています。',
          '傘下の<strong>深圳市千展供応链有限公司</strong>を中心に、KDS国際物流グループとして、輸出入業務、税関手続き、倉庫保管、配送までを一気通貫で提供。日本専門線のリーディングカンパニーとして、安定した品質と速達性を両立しています。',
          '「手頃な価格・便利・安全・スピーディー」をキーワードに、社会的価値と経済的価値を両立する高品質な物流サプライチェーンサービスプラットフォームの構築と提供に努めています。多くのお客様からのご愛顧とご信頼のおかげで、困難な状況下でも着実に実績を積み重ねることができました。',
          '今後も、KDSはお客様やパートナーの皆様と共に歩み、共に成長し、Win-Winの関係を築きながら、社会への貢献とさらなる価値創出を目指してまいります。',
        ],
      },
      history: {
        kicker: 'Development History', title: '沿革',
        lead: '2010年の設立から、KDSは事業領域を拡大し続けてきました。これからも、新たな価値創出に挑戦してまいります。',
        items: [
          { year: '2010', title: 'KDS物流、深圳で設立', desc: 'グローバル宅配（国際クーリエ）事業を主軸として深圳で創業。' },
          { year: '2013', title: '日本航空便ルートを自社構築', desc: '日本向け航空配送ルートを自社で構築開始。伝統物流を主軸として展開。' },
          { year: '2017', title: '坂田支店設立・EC物流参入', desc: '深圳市龍岗区坂田に支店を設立。EC物流分野へ進出を開始。' },
          { year: '2018', title: '海運物流ルートを自社構築', desc: '海運物流チャネルを自社で構築。航空・海運の両軸体制を確立。' },
          { year: '2019', title: '宝安支店設立', desc: '深圳市宝安区に支店を設立。同業者向け業務（フォワーダー向け）を主軸に展開。' },
          { year: '2020', title: '日本東京支店設立・海外倉構築', desc: '日本東京に分公司を設立。日本国内に自社海外倉を構築。' },
          { year: '2021', title: '千展供応链設立・コンプラソリューション', desc: '深圳市千展供応链有限公司を設立。日本食品衛生法・玩具規制・薬事法に対応するコンプライアンスソリューションを提供開始。' },
          { year: '2025', title: '製品安全四法 対応プラン提供', desc: '日本「製品安全四法」（電気用品安全法・消費生活用製品安全法・ガス事業法・液化石油ガス法）コンプライアンス備案ソリューションを提供開始。' },
          { year: 'Future', title: '更なる発展へ', desc: 'お客様と共に、新たな物流サービスの創造を続けます。', future: true },
        ],
      },
      culture: {
        kicker: 'Company Culture', title: '企業文化',
        vision: { en: 'CORPORATE VISION', title: '企業ビジョン', desc: '信頼される統合型スマートサプライチェーンサービスの提供企業へ', sub: 'To become a trustworthy integrated intelligent supply chain service provider' },
        spirit: { en: 'CORPORATE SPIRIT', title: '企業スピリット', desc: '心を込めたサービス。\n情熱と愛で感動を届け、\n努力で目標を達成する。' },
        core: { en: 'CORE VALUE', title: 'コアバリュー', desc: '信頼される物流企業。\n安心して任せられる、\n確かな配送サービス。' },
      },
      advantages: {
        kicker: 'Our Advantages', title: '私たちの優位性',
        lead: '20年超の国際物流経験を基盤に、KDSは独自の優位性を築いています。',
        items: [
          { num: '01', title: '20年超の国際物流チーム', desc: '業界経験豊富なベテラン専門人材が、複雑な案件にも一貫した品質で対応します。' },
          { num: '02', title: '充実した航空・海運スペース確保力', desc: '主要キャリアとの強固なパートナーシップで、繁忙期でも安定した船腹・席を確保。' },
          { num: '03', title: '国内外複数の自社運営倉庫', desc: '深圳の複数拠点と日本の東京・大阪倉庫により、シームレスな物流フローを実現。' },
          { num: '04', title: '強力な代理店ネットワーク', desc: '世界各地の信頼できるパートナー網で、エンドtoエンドの配送品質を担保。' },
          { num: '05', title: '可視化されたフルチェーン物流', desc: '自社OMSシステムにより、注文から配送完了までをリアルタイム可視化。' },
          { num: '06', title: '日本食品衛生法・薬事法対応', desc: '日本の食品輸入・医薬品関連の各種法規制に対応した認証・通関支援が可能。' },
          { num: '07', title: 'METI（経済産業省）届出対応', desc: 'METIコンプライアンス備案、日本進出に必要な行政手続きを一気通貫サポート。' },
        ],
      },
      qualifications: {
        kicker: 'Our Qualifications', title: '資格・認定',
        lead: '国際的な業界団体・中国政府関連機関から認定を受けた、信頼の物流パートナーです。',
        items: [
          { name: 'IATA', desc: '国際航空運送協会会員', sub: 'IATA Member' },
          { name: 'NVOCC', desc: '無船承運人資格', sub: 'Non-Vessel Operating Common Carrier' },
          { name: 'CIFA', desc: '一級貨運代理企業認定', sub: 'Class-A Freight Forwarder' },
        ],
      },
      profile: {
        kicker: 'Company Profile', title: '会社情報',
        rows: [
          { th: '会社名', td: 'KDS CO.LTD' },
          { th: '関連会社', td: '深圳市千展供応链有限公司（KDS国際物流グループ）\n株式会社千展商行（日本法人）' },
          { th: '設立', td: '2010年' },
          { th: '従業員数', td: '50名以上' },
          { th: '事業内容', td: '国際物流（航空・海運・陸送）／通関業務／倉庫・3PL／越境EC物流／FBA配送／宅配・Door-to-Door／コールドチェーン・特殊輸送／日本コンプライアンス対応' },
          { th: '本社所在地', td: '東京本社 〒150-0042 東京都渋谷区宇田川町1-12-1413' },
          { th: '中国拠点', td: '深圳市坪山区坑梓街道梓祥路6-4号五栋1楼\n深圳市龍岗区坂田街道中浩二路云力中心二楼218\n深圳市宝安区福海街道桥塘路福源工業区一栋1楼' },
          { th: '日本拠点', td: '東京倉庫（〒340-0006 埼玉県草加市八幡町）／大阪倉庫（〒599-8266 大阪府堺市中区）\n日本海外倉合計 20,000㎡以上' },
          { th: '取引実績', td: '3,000社以上の取引クライアント／累計輸出量 500,000 CBM以上' },
          { th: '資格・認定', td: 'IATA国際航空運送協会会員／NVOCC無船承運人資格／CIFA一級貨運代理企業' },
          { th: '輸出入拠点', td: '香港・深圳・広州・上海・青島の主要貿易港' },
          { th: 'カバーエリア', td: '日本（専門線）／韓国／シンガポール／マレーシア／タイ／フィリピン／インド／ロシア／中東諸国 ほか' },
        ],
      },
      cta: { title: 'KDSと、共に。', desc: 'お客様のビジネスに最適な物流ソリューションをご提案します。', btn: 'お問い合わせ' },
    },
    // Services page (JP)
    services: {
      hero: { breadcrumb: 'HOME / SERVICES', title: 'サービス紹介', lead: '日本専門線のリーディングカンパニーとして、航空・海運・FBA・海外倉庫・コンプライアンス対応まで一貫した物流ソリューションを提供します。' },
      transit: [
        { label: '航空商業 D2D', value: '最速1日' },
        { label: '航空FBA', value: '3-5営業日' },
        { label: '海上商業 D2D', value: '最速5日' },
        { label: '海上FBA', value: '10-15営業日' },
        { label: '倉庫出荷', value: '1-3日（全国）' },
      ],
      details: [
        {
          id: 'air', num: 'SERVICE 01', title: '航空輸送・チャーター便', en: 'Air Transport & Charter Flights',
          leadTime: '24-48時間で配送',
          desc: '緊急貨物や時間制約のある荷物に対応。ANA・キャセイ・チャイナエアラインなど主要航空会社と連携した、高速かつ柔軟な輸送網を提供します。',
          features: [
            { key: 'SPEED', val: '中国主要5空港から日本へ、24-48時間の高速配送。' },
            { key: 'STABILITY', val: '優先スペース確保、欠航リスクなく定時運行。' },
            { key: 'PAPERWORK', val: '日中バイリンガル書類作成、両国税関手続きを効率的に対応。' },
            { key: 'INSURANCE', val: '貨物保険付き、電子機器・精密機器など高額商品の安全を確保。' },
            { key: 'SENSITIVE', val: '定温・防振梱包、生鮮・医薬品・美術品などセンシティブ貨物の専門対応。' },
          ],
        },
        {
          id: 'sea', num: 'SERVICE 02', title: '海上輸送（Clipper Service）', en: 'Sea Transport',
          leadTime: '最速2〜3日（高速船）／3〜6日（コスト優先船）',
          desc: '高速船で最速2〜3日、コスト優先船で3〜6日。スピードとコストのバランスをお選びいただける、信頼性の高い国際海上輸送サービスです。',
          features: [
            { key: 'FCL / LCL', val: 'FCL（コンテナ単位）・LCL（混載）両対応。柔軟な混載配送。' },
            { key: 'VOLUME', val: '大口貨物に専用割引＋スペース・コンテナ確保サービス。' },
            { key: 'STABILITY', val: '最速2〜3日、安定したスケジュールで日本全港カバー。' },
            { key: 'HAZMAT', val: '9クラス危険物対応、MSDS専門事前審査。' },
          ],
        },
        {
          id: 'ec', num: 'SERVICE 03', title: '越境EC・FBA配送', en: 'Cross-border E-commerce',
          leadTime: '航空便 約3日／海上便 約10日',
          desc: 'Amazon FBAをはじめ越境ECに最適化した配送・在庫管理を一括提供します。',
          features: [
            { key: 'FULL CARE', val: 'FBAヘッダー全程委託、代行受取・検品・ラベル貼付・仕分け。' },
            { key: 'FBA READY', val: 'Amazon入庫要件に厳密に準拠した事前処理、貨物拒否を防止。' },
            { key: 'RETURNS', val: '返品逆物流。日本国内の返品・交換品の中国返送を一括対応。' },
            { key: 'TAX INCLUDED', val: '航空便DDP通関・関税込。高額関税問題を解決。Prime会員向け緊急補充対応。' },
            { key: 'SENSITIVE', val: 'センシティブ貨物専門プラン：バッテリー/化粧品/食品接触商品のコンプライアンス出荷。' },
          ],
        },
        {
          id: 'sea-fba', num: 'SERVICE 04', title: '海上FBA', en: 'Sea FBA Service',
          leadTime: '10-15営業日　／　海上コスト45%削減',
          desc: '海上輸送のスケールメリットとFBA配送の信頼性を両立。普船・快速船・コンテナ通関・個別通関の多様なモードを提供。',
          features: [
            { key: 'COST −45%', val: '海上コスト45%削減。継続出荷で物流費を大幅圧縮。' },
            { key: 'MULTI MODE', val: '普船・快速船・コンテナ通関・個別通関の多モード対応。' },
            { key: 'JCT / IOR', val: '日本輸入者名義無料提供、JCT/IORコンプライアンス申告対応。' },
            { key: 'ALL INCLUSIVE', val: '逆算込み・関税込み・通関込み、隠れた費用一切なし。' },
            { key: 'SENSITIVE PASS', val: 'センシティブ貨物専門チャネル、電磁・磁気・食品衛生法・薬事法対応100%通関保証。' },
          ],
        },
        {
          id: 'warehouse', num: 'SERVICE 05', title: '海外倉庫サービス', en: 'Overseas Warehouse',
          leadTime: '24時間出荷　／　日本全国1-3日配送',
          desc: 'KDS海外倉庫は東京と大阪に設置、合計50,000㎡、埠頭・空港から車で1時間の好立地。同時に20コンテナ以上の作業が可能。',
          features: [
            { key: 'FACILITY', val: '東京・大阪の自社倉庫50,000㎡。20コンテナ以上の同時作業が可能。' },
            { key: 'BONDED', val: '保税倉庫と一般倉庫を併設、輸入キャッシュフローを最適化。' },
            { key: 'OMS', val: '強力なOMSシステム連携、リアルタイム在庫監視、注文自動処理。' },
            { key: 'SHIP IN 24H', val: '24時間出荷を実現、日本全国へ最短1-3日で配送。' },
            { key: 'SMART', val: 'スマートシステムで在庫アラート・自動補充、欠品・過剰在庫を防止。' },
          ],
        },
        {
          id: 'compliance', num: 'SERVICE 06', title: '日本コンプライアンス対応', en: 'Japan Compliance Solutions',
          leadTime: '専門チームによる届出代行・認証サポート',
          desc: '日本市場参入に必要な各種法規制対応。認証取得から行政届出までワンストップで、中国ブランドの海外展開を専門チームがサポート。',
          features: [
            { key: 'FOOD LAW', val: '日本食品衛生法対応。食品輸入届出、成分表確認、検査手配等。' },
            { key: 'PHARMA', val: '薬事法（医薬品医療機器等法）対応。医療機器・化粧品の輸入許可サポート。' },
            { key: 'METI', val: 'METI（経済産業省）届出、各種行政手続き代行。' },
            { key: 'SAFETY 4 LAWS', val: '製品安全四法（電安法・消安法・ガス事業法・液石法）届出対応。' },
            { key: 'TOY REG', val: '児童玩具・文具の安全基準・STマーク取得関連サポート。' },
          ],
        },
        {
          id: 'special', num: 'SERVICE 07', title: '特殊輸送・コールドチェーン', en: 'Cold Chain & Special Cargo',
          leadTime: '温度管理・専門輸送ソリューション',
          desc: '温度管理が必要な製品、医療品・化粧品の特別輸送、危険物特殊輸送まで、専門知識を要する貨物に対応します。',
          features: [
            { key: 'COLD CHAIN', val: '定温・冷蔵・冷凍の多温度帯、各温度要件に最適な輸送手段を選定。' },
            { key: 'MEDICAL', val: '医療機器・医薬品の特殊輸送。各国規制対応サポート。' },
            { key: 'COSMETIC', val: '化粧品輸送に必要な書類・通関手続きサポート。' },
            { key: 'HAZMAT', val: '危険物特殊輸送（9クラス対応）。IATA/IMDG準拠の安全輸送。' },
            { key: 'HIGH VALUE', val: '電子機器・精密機器・美術品等高額商品の専門梱包。' },
          ],
        },
      ],
      flow: {
        kicker: 'Operation Flow', title: '10ステップの一貫輸送フロー', lead: 'お見積りから受領まで、全工程をKDSが管理します。',
        steps: [
          { num: '01', title: '口座開設/見積', desc: '取引口座の開設と料金プランの確認。' },
          { num: '02', title: '注文確定', desc: '仕様・納期・配送条件の最終確認。' },
          { num: '03', title: '貨物準備', desc: '梱包・ラベル貼付・出荷書類の準備。' },
          { num: '04', title: 'ブッキング/入庫', desc: 'フライト・船便の予約、保税倉庫への入庫手続き。' },
          { num: '05', title: '輸出通関', desc: '中国輸出申告と通関手続きの完了。' },
          { num: '06', title: '積込輸送', desc: '航空便・海上便で日本へ国際輸送。' },
          { num: '07', title: '輸入通関', desc: '日本輸入申告と税関検査の完了。' },
          { num: '08', title: '目的港作業', desc: '港・空港でのコンテナ取出しと荷下ろし作業。' },
          { num: '09', title: '倉庫仕分け', desc: '必要に応じてKDS倉庫で仕分け・保管・FBA加工。' },
          { num: '10', title: '配送/受領', desc: '最終受取人へ配送し、受領完了。' },
        ],
      },
      coverage: {
        kicker: 'Full Coverage', title: '4つのコア機能、全チェーンサポート', lead: '受注から受領、アフターサービスまで、全工程をKDSが一元管理。',
        items: [
          { num: '01', title: '受注管理', desc: '自社OMSシステムで発注から出荷までの全工程を一元管理、リアルタイムに注文状況を把握。' },
          { num: '02', title: '倉庫・在庫管理', desc: '最新WMSシステムによる効率的な在庫管理とSKU単位の総合保管・出荷作業。' },
          { num: '03', title: '国際輸送・追跡', desc: 'グローバルな輸送ネットワークと高精度の追跡システムで、安心の輸送状況可視化を提供。' },
          { num: '04', title: 'アフターサービス', desc: '返品交換管理を含む総合的なアフターサポートで、事業の継続的運営を支援。' },
        ],
      },
      cta: { title: 'お客様の貨物に、最適なプランを。', desc: 'サービス組み合わせのご相談、お見積りはお気軽にどうぞ。', btn: 'お問い合わせ' },
    },
    // Network page (JP)
    network: {
      hero: { breadcrumb: 'HOME / NETWORK', title: '拠点・ネットワーク', lead: '深圳3拠点・日本3拠点、グローバル主要キャリア・配送パートナーネットワークがKDS独自の専用ラインを構成します。' },
      global: { kicker: 'Global Network', title: '世界をつなぐ専用ライン' },
      chinaOffices: {
        kicker: 'China Offices', title: '中国国内3拠点',
        lead: '深圳市内3拠点で坪山・龍岗・宝安エリアをカバー。各事業に最適な拠点配置。',
        offices: [
          { pin: 'SHENZHEN PINGSHAN', title: '坪山拠点（本社）', addr: '深圳市坪山区\n坑梓街道梓祥路6-4号五栋1楼', role: '主要運営拠点。通関・倉庫業務の中核。' },
          { pin: 'SHENZHEN BANTIAN', title: '龍岗坂田拠点', addr: '深圳市龍岗区\n坂田街道中浩二路\n云力中心二楼218', role: '2017年設立。EC物流分野の中核拠点。' },
          { pin: 'SHENZHEN BAOAN', title: '宝安拠点', addr: '深圳市宝安区\n福海街道桥塘路\n福源工業区一栋1楼', role: '2019年設立。同業者向け業務（フォワーダー向け）の中核。' },
        ],
      },
      japanOffices: {
        kicker: 'Japan Offices', title: '日本国内拠点',
        lead: 'グローバル物流のプロフェッショナルとして、東京と大阪に戦略的拠点を配置し、日本全国をカバーします。',
        offices: [
          { pin: 'TOKYO OFFICE', title: '東京オフィス', addr: '〒150-0042\n東京都渋谷区宇田川町1-12-1413', role: 'グローバル戦略・顧客サポートの中心拠点。営業・カスタマーサービスを統括。' },
          { pin: 'TOKYO WAREHOUSE', title: '東京倉庫', addr: '〒340-0006\n埼玉県草加市八幡町', role: '関東圏物流の主要ハブ。日本海外倉24時間出荷対応。' },
          { pin: 'OSAKA WAREHOUSE', title: '大阪倉庫', addr: '〒599-8266\n大阪府堺市中区', role: '西日本エリア配送の効率化を実現する戦略拠点。最短1-3日で全国配送。' },
        ],
      },
      chinaHubs: {
        kicker: 'China Hubs', title: '輸出入5大貿易港',
        lead: '中国の主要貿易港をカバーし、輸送・通関・配送の一貫サービスを提供。',
        regions: [
          { en: 'SHENZHEN', cn: '深圳', sub: '本社・主要倉庫拠点' },
          { en: 'HONG KONG', cn: '香港', sub: '輸出入中継・主要海港・空港' },
          { en: 'GUANGZHOU', cn: '広州', sub: '華南地域物流ハブ' },
          { en: 'SHANGHAI', cn: '上海', sub: '華東地域貿易港' },
          { en: 'QINGDAO', cn: '青島', sub: '華北地域海運拠点' },
        ],
      },
      asia: {
        kicker: 'Asia & Beyond', title: '専用ライン展開エリア',
        lead: '日本・韓国・東南アジアの専用物流ラインでの成功を基盤に、インド・ロシア・中東諸国へも専用ラインを展開。',
        regions: [
          { en: 'JAPAN', cn: '日本（専門線）' },
          { en: 'KOREA', cn: '韓国' },
          { en: 'SOUTHEAST ASIA', cn: 'シンガポール・マレーシア・タイ・フィリピン 他' },
          { en: 'INDIA', cn: 'インド' },
          { en: 'RUSSIA', cn: 'ロシア' },
          { en: 'MIDDLE EAST', cn: '中東諸国' },
        ],
      },
      carriers: {
        kicker: 'Strategic Carriers', title: '提携キャリア',
        lead: '海運・航空の主要キャリアと長期パートナーシップを構築し、安定した船腹・航空スペースを確保。',
        groups: [
          {
            cat: '海上輸送 — Sea Carriers',
            items: [
              { en: 'JJ SHIPPING', cn: '錦江航運' },
              { en: 'EVERGREEN', cn: '長栄海運' },
              { en: 'SITC', cn: 'SITC国際' },
              { en: 'T.S. LINES', cn: '德翔海運' },
              { en: 'COSCO', cn: '中遠海運' },
            ],
          },
          {
            cat: '航空輸送 — Air Carriers',
            items: [
              { en: 'CHINA SOUTHERN', cn: '中国南方航空' },
              { en: 'SF AIRLINES', cn: '順豊航空' },
              { en: 'CATHAY PACIFIC', cn: 'キャセイパシフィック航空' },
              { en: 'ANA', cn: '全日空' },
              { en: 'JAL', cn: '日本航空' },
            ],
          },
          {
            cat: '日本国内配送パートナー — Japan Last-Mile Partners',
            items: [
              { en: 'JP POST', cn: '日本郵便' },
              { en: 'YAMATO', cn: 'ヤマト運輸' },
              { en: 'SAGAWA', cn: '佐川急便' },
              { en: 'FUKUYAMA', cn: '福山通運' },
              { en: 'SEINO', cn: '西濃運輸' },
              { en: 'TONAMI', cn: 'TONAMI' },
            ],
          },
          {
            cat: '国際物流パートナー — International Express',
            items: [
              { en: 'OCS', cn: 'OCS World Network' },
              { en: 'DHL', cn: 'DHL Express' },
            ],
          },
        ],
      },
      cta: { title: 'お客様の目的地へ、KDSがつなぎます。', desc: '新規ライン構築のご相談もお気軽にどうぞ。', btn: 'お問い合わせ' },
    },
    // Tracking page (JP)
    tracking: {
      hero: { breadcrumb: 'HOME / TRACKING', title: '貨物追跡', lead: '追跡番号を入力すると、貨物の配送状況をリアルタイムで確認できます。' },
      form: { title: '追跡番号検索', desc: '配送伝票または出荷通知メールに記載の追跡番号を入力してください。', placeholder: '例: KDS202604260001', hint: 'サンプル追跡番号：KDS202604260001（配送中）／KDS202604200088（受領済）' },
      empty: '該当する追跡番号が見つかりませんでした。番号をご確認の上、再度お試しください。',
      faq: {
        kicker: 'FAQ', title: '追跡について',
        rows: [
          { th: '更新頻度', td: '配送状況は約30分ごとに更新されます。通関やフライトの影響で遅延が生じる場合があります。' },
          { th: '番号形式', td: '"KDS" + 日付（YYYYMMDD）+ 4桁の連番 が基本形式です。出荷通知メール・配送伝票でご確認いただけます。' },
          { th: '検索できない場合', td: '出荷後、登録待機時間が発生することがあります。半日以上経過しても表示されない場合は、お問い合わせください。' },
          { th: '複数検索', td: '現在の追跡画面では1件ずつの検索に対応しています。企業のお客様はバルク追跡APIをご利用いただけます。' },
        ],
      },
    },
    // Contact page (JP)
    contact: {
      hero: { breadcrumb: 'HOME / CONTACT', title: 'お問い合わせ', lead: 'お見積り、専用ライン構築、その他物流に関するご相談をお気軽にどうぞ。' },
      info: {
        kicker: 'Get in touch', title: 'お問い合わせ先', desc: '通常2営業日以内にご返信いたします。お急ぎの場合はお電話にてご連絡ください。',
        items: [
          { key: 'HQ', val: '東京本社\n〒150-0042 東京都渋谷区宇田川町1-12-1413' },
          { key: 'SHENZHEN', val: '中国深圳本社（坪山）：\n深圳市坪山区坑梓街道梓祥路6-4号五栋1楼\n\n坂田拠点：\n深圳市龍岗区坂田街道中浩二路云力中心二楼218\n\n宝安拠点：\n深圳市宝安区福海街道桥塘路福源工業区一栋1楼' },
          { key: 'JAPAN', val: '東京倉庫：埼玉県草加市八幡町（〒340-0006）\n大阪倉庫：大阪府堺市中区（〒599-8266）' },
          { key: 'HOURS', val: '営業日 9:00〜18:00\n（土日祝日を除く）' },
          { key: 'EMAIL', val: 'info@kds-logistics.example' },
          { key: 'PHONE', val: '+81 XXX-XXXX-XXXX' },
        ],
      },
      form: {
        fields: {
          name: 'お名前', company: '会社名', email: 'メールアドレス', phone: '電話番号',
          category: 'お問い合わせ種別', message: 'お問い合わせ内容',
        },
        placeholders: {
          name: '山田 太郎', company: '株式会社○○', email: 'example@company.com',
          phone: '+81 XXX-XXXX-XXXX', message: '貨物の概要、出発地・目的地、ご希望の納期などをご記入ください。',
        },
        categories: ['選択してください', '航空輸送', '海上輸送', '日本海外倉庫', '越境EC・FBA配送', '宅配サービス', '特殊輸送・コールドチェーン', '日本コンプライアンス対応', 'お見積り依頼', 'その他'],
        submit: '送信',
      },
    },
  },
};

export default data;